import { render } from "./IconMenuKanriComponent.vue?vue&type=template&id=6fd33c7a&ts=true"
import script from "./IconMenuKanriComponent.vue?vue&type=script&lang=ts"
export * from "./IconMenuKanriComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__